import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./ErrorBoundary";
import { translate, browserLocale } from "./i18n";
import { registerServiceWorker } from "./push";
import "./styles.css";
import "./home.css";
import "./questionnaire.css";
import "./m4.css";
import "./m5b.css";
import "./app-wizard.css";
import "./staff.css";
// Design layer over the partner surfaces; must follow staff.css so its
// equal-specificity overrides win (partner-design 2026-08-05).
import "./staff/partner-view.css";
import "./video.css";
// Last, so the toast layer wins over the per-toast fallback positions.
import "./toast.css";

registerServiceWorker();

// Last-resort boundary: even if App itself throws before it can resolve a
// locale, the boundary renders a recoverable card instead of a white screen.
const rootT = (key: string) => translate(browserLocale(), key);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary t={rootT}>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
